export type ReportingPeriod = {
  startDate: Date;
  endDate: Date;
};

/**
 * Build an inclusive local-calendar preset.
 *
 * "Last 30 days" means today plus the preceding 29 local dates. Using
 * subDays(now, 30) would select 31 dates before the database even sees the
 * range. Keeping the boundaries in local time also lets the server receive the
 * correct UTC instants for a warehouse day.
 */
export function buildPresetReportingPeriod(days: number, now = new Date()): ReportingPeriod {
  const inclusiveDays = Number.isFinite(days) ? Math.max(1, Math.trunc(days)) : 1;
  const endDate = new Date(now);
  endDate.setHours(23, 59, 59, 999);

  const startDate = new Date(now);
  startDate.setDate(startDate.getDate() - (inclusiveDays - 1));
  startDate.setHours(0, 0, 0, 0);

  return { startDate, endDate };
}
